<template>
  <div ref="dropdown" class="dropdown">
    <li class="nav-item" @click="toggleDropdown">
      <slot name="toggle" :toggle="toggleDropdown"></slot>
    </li>

    <Teleport v-if="isOpen" to="body">
      <transition name="slide-menu" appear>
        <div v-if="isOpen" ref="dropdownMenu" class="dropdown-menu" role="menu">
          <slot />
        </div>
      </transition>
    </Teleport>
  </div>
</template>

<script>
import { computePosition, flip, shift, offset, autoUpdate } from "@floating-ui/dom";

export default {
  name: "BDropdown",
  components: {},

  props: {
    variant: { type: String, default: "secondary" },
    size: { type: String, default: "md" },
    outline: { type: Boolean, default: false },
    label: { type: String, default: "Dropdown" },
    btnClass: { type: String, default: "" },
    placement: { type: String, default: "bottom-center" },
  },

  data() {
    return {
      isOpen: false,
      cleanup: null,
    };
  },

  beforeUnmount() {
    this.cleanup?.();
    document.removeEventListener("click", this.handleOutsideClick);
  },

  methods: {
    hide() {
      if (this.isOpen) {
        this.toggleDropdown();
      }
    },

    toggleDropdown() {
      this.isOpen = !this.isOpen;

      if (this.isOpen) {
        this.$nextTick(this.setupPosition);
        document.addEventListener("click", this.handleOutsideClick);
      } else {
        document.removeEventListener("click", this.handleOutsideClick);
        this.cleanup?.();
      }
    },

    setupPosition() {
      const reference = this.$refs.dropdown;
      const floating = this.$refs.dropdownMenu;

      if (!reference || !floating) return;

      this.cleanup = autoUpdate(reference, floating, () => {
        computePosition(reference, floating, {
          strategy: "fixed",
          placement: this.placement,
          middleware: [offset(4), flip({ padding: 8 }), shift({ padding: 8 })],
        }).then(({ x, y }) => {
          Object.assign(floating.style, {
            position: "fixed",
            left: `${x}px`,
            top: `${y}px`,
          });
        });
      });
    },

    handleOutsideClick(event) {
      const isOutside = !this.$refs.dropdown?.contains(event.target) && !this.$refs.dropdownMenu?.contains(event.target);

      if (isOutside) {
        this.toggleDropdown();
        return;
      }

      if (event.target.classList.contains("dropdown-item") || event.target.parentElement.classList.contains("dropdown-item")) {
        this.toggleDropdown();
      }
    },
  },
};
</script>

<style scoped>
.dropdown-menu {
  position: fixed;
  margin: 0;
  padding: 0.5rem 0;
  min-width: 150px;
  background: white;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  transform-origin: top;
  transition:
    transform 0.2s ease,
    opacity 0.2s ease;
}

.slide-menu-enter-active,
.slide-menu-leave-active {
  transition:
    transform 0.2s ease,
    opacity 0.2s ease;
}

.slide-menu-enter-from,
.slide-menu-leave-to {
  opacity: 0;
  transform: translateY(-10px) scale(0.95);
}

.slide-menu-enter-to,
.slide-menu-leave-from {
  opacity: 1;
  transform: translateY(0) scale(1);
}
</style>
